import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import {
  Form,
  Button,
  Card,
  Breadcrumb,
  Container,
  Alert,
} from "react-bootstrap";

const FormAddUser = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confPassword, setConfPassword] = useState("");
  const [role, setRole] = useState("");
  const [msg, setMsg] = useState("");
  const navigate = useNavigate();

  const saveUser = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem("token");

    try {
      await axios.post(
        `https://c-greenproject.org:8000/users/`,
        {
          name,
          email,
          password,
          confPassword,
          role,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      navigate("/users");
    } catch (error) {
      if (error.response) {
        setMsg(error.response.data.msg);
      }
    }
  };

  return (
    <Container>
      <Breadcrumb className="pt-3">
        <Breadcrumb.Item href="/users">List User</Breadcrumb.Item>
        <Breadcrumb.Item active>Add New User</Breadcrumb.Item>
      </Breadcrumb>

      <h2 className="mb-4">
        <strong>Add New User</strong>
      </h2>

      <Card className="shadow-sm mb-3">
        <Card.Body>
          <Form onSubmit={saveUser}>
            {msg && <Alert variant="danger" className="text-center">{msg}</Alert>}

            <Form.Group className="mb-3">
              <Form.Label>Nama</Form.Label>
              <Form.Control
                type="text"
                placeholder="Nama"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Password</Form.Label>
              <Form.Control
                type="password"
                placeholder="******"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Confirm Password</Form.Label>
              <Form.Control
                type="password"
                placeholder="******"
                value={confPassword}
                onChange={(e) => setConfPassword(e.target.value)}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Role</Form.Label>
              <Form.Select
                value={role}
                onChange={(e) => setRole(e.target.value)}
              >
                <option value="">Pilih Role</option>
                <option value="admin">Admin</option>
                <option value="petani">Petani</option>
                <option value="logistik">Logistik</option>
                <option value="pabrik">Pabrik</option>
              </Form.Select>
            </Form.Group>

            <div className="text-end">
              <Button variant="success" type="submit">
                Save
              </Button>
            </div>
          </Form>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default FormAddUser;
